var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76416 12C8.76416 14.1333 10.5105 15.8691 12.6666 15.8691C14.8129 15.8691 16.5593 14.1333 16.5593 12C16.5593 9.85697 14.8129 8.12121 12.6666 8.12121C10.5105 8.12121 8.76416 9.85697 8.76416 12ZM18.4032 6.04606C20.1105 7.36485 21.5642 9.29455 22.6081 11.7091C22.6861 11.8933 22.6861 12.1067 22.6081 12.2812C20.5203 17.1103 16.8032 20 12.6666 20H12.6568C8.53001 20 4.81294 17.1103 2.72513 12.2812C2.64708 12.1067 2.64708 11.8933 2.72513 11.7091C4.81294 6.88 8.53001 4 12.6568 4H12.6666C14.7349 4 16.6959 4.71758 18.4032 6.04606ZM12.6678 14.4124C14.0044 14.4124 15.097 13.3264 15.097 11.9979C15.097 10.6597 14.0044 9.57362 12.6678 9.57362C12.5507 9.57362 12.4336 9.58332 12.3263 9.60272C12.2873 10.6694 11.4092 11.5227 10.3263 11.5227H10.2775C10.2483 11.6779 10.2287 11.833 10.2287 11.9979C10.2287 13.3264 11.3214 14.4124 12.6678 14.4124Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowBold);
export default __webpack_public_path__ + "static/media/show-bold.7c65ded8d663b7f5a53e85a7c4671ecf.svg";
export { ForwardRef as ReactComponent };